import { useMemo } from 'react';
import { Delaunay } from 'd3';

export const VoronoiOverlay = ({
  innerWidth,
  innerHeight,
  allData,
	lineGenerator,
  onHover,
  onSelect,
  onTap,
}) => {
    return useMemo(() => {

    const points = allData.map((d) => [
      lineGenerator.x()(d),
      lineGenerator.y()(d)
    ]);



    const delaunay = Delaunay.from(points);
    const voronoi = delaunay.voronoi([
      0,
      0,
      innerWidth,
      innerHeight,
    ]);

    return (
    <g className={(onSelect || onTap) ? 'voronoi voronoi-clickable' : 'voronoi'}>
      {points.map((point, i) => (
        <path
          key={i}
          onMouseEnter={() => onHover(allData[i])}
          onClick={onSelect ? () => onSelect(allData[i]) : undefined}
          onTouchStart={onTap ? () => onTap(allData[i]) : undefined}
          d={voronoi.renderCell(i)}
        />
      ))}
    </g>
    );
  }, [
      allData,
		  lineGenerator,
      innerWidth,
      innerHeight,
      onHover,
      onSelect,
      onTap,
  ]);
};
